import { APICore } from "./apiCore";

const api = new APICore();

const listarDiasDaSemana = () => {
    return api.get(`/dia-semana`);
};

export { listarDiasDaSemana };
